import React from "react";
import { Box, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";

import Container from "@mui/material/Container";
import { makeStyles } from "@mui/styles";
import TestReport from "./TestReport";
import Possibility from "./Possibility";
import InfoIcon from "@mui/icons-material/Info";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import { Link } from "react-router-dom";
import ExpWithPicRight from "../ExpWithPicRight";
import ExpWithPicLeft from "../ExpWithPicLeft";
import PageTop from "../PageTop";
import { useTranslation } from "react-i18next";
import Fade from "react-reveal/Fade";

const Tech = () => {
  document.title = "Heslet Technology";
  const classes = useStyles();
  const { t, i18n } = useTranslation();

  return (
    <>
      <Fade delay={400}>
        <PageTop
          bottom="15"
          title={t("living_better")}
          smallTitle={t("living_better2")}
          img="https://images.unsplash.com/photo-1582560486381-e6a01d8f5bb7?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2072&q=80"
        />
      </Fade>

      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <ExpWithPicRight
          smallTitle={t("unique")}
          title={t("tech")}
          content={t("tech_exp")}
          imgUrl="img/yaytg623921.jpg"
        />
      </Box>

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          backgroundColor: "#f6f8fa",
        }}
      >
        <Grid
          maxWidth="lg"
          container
          sx={{
            width: 1,
            display: "flex",
            alignItems: "center",
            flexDirection: "row",
          }}
        >
          <Grid item md={12} sm={12} sx={{ px: 6, pt: 10, fontSize: "30px" }}>
            <section id="hybrid-max"></section>
            <Typography sx={{ pb: 1, color: "#153a5b", fontWeight: "bold" }}>
              {t("tech_hybrid")}
            </Typography>
            <Typography sx={{ fontSize: "32px", fontWeight: 500 }}>
              {t("hybrid_max")}
            </Typography>
            <Typography sx={{ lineHeight: "200%", pt: 3, fontSize: "14px" }}>
              <div
                dangerouslySetInnerHTML={{ __html: t("hybrid_max_exp_full") }}
              />
            </Typography>
          </Grid>
          <Grid
            md={12}
            sm={12}
            sx={{
              px: 6,
              lineHeight: "180%",
              pt: 5,
              pb: 10,
              fontSize: "14px",
            }}
          >
            <Typography sx={{ fontSize: "32px", fontWeight: 500 }}>
              {t("Specialty")}
            </Typography>
            <ul>
              <li>{t("specialty1")}</li>
              <li>{t("specialty2")}</li>
            </ul>

            {/* <button className="custom_btn_withOrangebg">Learn More</button> */}
          </Grid>
        </Grid>
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          py: 10,
        }}
      >
        <ExpWithPicRight
          smallTitle={t("HybridMax-Liquid_small")}
          title={t("HybridMax-Liquid")}
          content={t("hybridmax_exp_full")}
          imgUrl="img/yaytg310309.jpg"
        />
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          backgroundColor: "#f6f8fa",
        }}
      >
        <Grid
          maxWidth="lg"
          container
          sx={{
            width: 1,
            display: "flex",
            alignItems: "center",
            flexDirection: "row",
          }}
        >
          <Grid item md={12} sm={12} sx={{ px: 6, pt: 10, fontSize: "30px" }}>
            <section id="hybrid-max"></section>
            <Typography sx={{ pb: 1, color: "#153a5b", fontWeight: "bold" }}>
              {t("ultra_small")}
            </Typography>
            <Typography sx={{ fontSize: "32px", fontWeight: 500 }}>
              <section id="ultra-phenix"></section>
              {t("Ultra_Phenix")}
            </Typography>
            <Typography sx={{ lineHeight: "200%", pt: 3, fontSize: "14px" }}>
              <div
                dangerouslySetInnerHTML={{ __html: t("Ultra_Phenix_exp_full") }}
              />
            </Typography>
          </Grid>
          <Grid
            md={12}
            sm={12}
            sx={{
              px: 6,
              lineHeight: "180%",
              pt: 5,
              pb: 10,
              fontSize: "14px",
            }}
          >
            <Typography sx={{ fontSize: "32px", fontWeight: 500 }}>
              {t("Specialty")}
            </Typography>
            <ul>
              <li>{t("specialty3")}</li>
              <li>{t("specialty4")}</li>
              <li>
                {" "}
                <div
                  dangerouslySetInnerHTML={{
                    __html: t("specialty5"),
                  }}
                />
              </li>
            </ul>

            {/* <button className="custom_btn_withOrangebg">Learn More</button> */}
          </Grid>
        </Grid>
      </Box>

      <Box sx={{ display: "flex", justifyContent: "center", py: 15 }}>
        <ExpWithPicLeft
          smallTitle={t("Antimicrobial")}
          title={t("HybridMax-Compound")}
          content={t("HybridMax-Compound_exp")}
          imgUrl="img/yaytg622704.jpg"
        />
      </Box>
      <section id="magic-clean"></section>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          backgroundColor: "#f6f8fa",
        }}
      >
        <Grid
          maxWidth="lg"
          container
          sx={{
            width: 1,
            display: "flex",
            alignItems: "center",
            flexDirection: "row",
          }}
        >
          <Grid item md={12} sm={12} sx={{ px: 6, pt: 10, fontSize: "30px" }}>
            <section id="hybrid-max"></section>
            <Typography sx={{ pb: 1, color: "#153a5b", fontWeight: "bold" }}>
              {t("magic_small")}
            </Typography>
            <Typography sx={{ fontSize: "32px", fontWeight: 500 }}>
              {t("magic")}
            </Typography>
            <Typography sx={{ lineHeight: "200%", pt: 3, fontSize: "14px" }}>
              <div dangerouslySetInnerHTML={{ __html: t("magic_full") }} />
            </Typography>
          </Grid>
          <Grid
            md={12}
            sm={12}
            sx={{
              px: 6,
              lineHeight: "180%",
              pt: 5,
              pb: 10,
              fontSize: "14px",
            }}
          >
            <Typography sx={{ fontSize: "32px", fontWeight: 500 }}>
              {t("Specialty")}
            </Typography>
            <ul>
              <li>{t("specialty3")}</li>
              <li>{t("specialty4")}</li>
              <li>{t("specialty6")}</li>
            </ul>

            {/* <button className="custom_btn_withOrangebg">Learn More</button> */}
          </Grid>
        </Grid>
      </Box>

      {/* <Box
				sx={{
					display: "flex",
					justifyContent: "center",
				}}
			>
				<Grid
					maxWidth="lg"
					container
					sx={{
						width: 1,
						display: "flex",
						alignItems: "center",
						flexDirection: "row",
						// border: "1px solid black",
					}}
				>
					<Grid item md={6} sm={12} sx={{ px: 6, py: 20, fontSize: "30px" }}>
						<section id="magic-clean"></section>
						<Typography color="secondary" sx={{ pb: 1 }}>
							Eco-friendly Functional Paint Technology
						</Typography>
						<Typography variant="h3">Magic Clean</Typography>
						<Typography sx={{ lineHeight: "170%", pt: 3, fontSize: "17px" }}>
							Magic Clean Paint technology is an eco-friendly functional paint
							which removes the doodles from the wall very effectively. <br />
							<br />
							It has the advantage of easily erasing the contamination of
							various food products or scribbles such as oil pens, ball pens,
							crayons and pencils with wet wipes. Even if you erase it with a
							wet wipe, there is no color deformation of the paint. <br />
							<br />
							In particular, it is a new technology that is resistant to
							ultraviolet rays with superior durability and is manufactured to
							create any colors.
						</Typography>
					</Grid>
					<Grid
						md={6}
						sm={12}
						sx={{
							px: 6,
							lineHeight: "180%",
							py: 23,
							fontSize: "17px",
						}}
					>
						<Typography variant="h3">Specialty</Typography>
						<ul className="orangeList">
							<li>Non Framable</li>
							<li>Full Protection</li>
							<li>UV Protection</li>
						</ul>
						<br />
						<br />
						<br />
						<br />
						<br />
						<button className="custom_btn_withOrangebg">Learn More</button>
					</Grid>
				</Grid>
			</Box> */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Grid
          maxWidth="lg"
          container
          sx={{
            width: 1,
            display: "flex",
            alignItems: "center",
            flexDirection: "row",
            // border: "1px solid black",
          }}
        >
          <Grid item sm={12} sx={{ px: 6, pt: 10, pb: 20, fontSize: "30px" }}>
            <Typography sx={{ pb: 1, color: "#153a5b" }}>
              {t("Our_products_test")}
            </Typography>
            <Typography sx={{ fontSize: "32px", fontWeight: 500 }}>
              {t("Test")}
            </Typography>
            <Typography sx={{ lineHeight: "170%", pt: 1 }}>
              {t("test_small")}
            </Typography>
            <Grid
              container
              sx={{
                width: 1,

                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <Grid
                item
                sm={4}
                md={2}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  pt: 3,
                }}
              >
                <TestReport
                  img="img/katri.jpeg"
                  content={t("test1")}
                  src="anti-bacterial activity test report - 7days.pdf"
                />
              </Grid>
              <Grid
                item
                sm={4}
                md={2}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  pt: 3,
                }}
              >
                <TestReport
                  img="img/katri.jpeg"
                  content={t("test2")}
                  src="bactericidal activity test report - 1min.pdf"
                />
              </Grid>
              <Grid
                item
                sm={4}
                md={2}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  pt: 3,
                }}
              >
                <TestReport
                  img="img/katri.jpeg"
                  content={t("test3")}
                  src="bactericidal activity test report - 3min.pdf"
                />
              </Grid>
              <Grid
                item
                sm={4}
                md={2}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  pt: 3,
                }}
              >
                <TestReport
                  img="img/katri.jpeg"
                  content={t("test4")}
                  src="bactericidal activity test report - 24hour.pdf"
                />
              </Grid>
              <Grid
                item
                sm={4}
                md={2}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  pt: 3,
                }}
              >
                <TestReport
                  img="img/katri.jpeg"
                  content={t("test5")}
                  src="Pet] anti-bacterial activity test report.pdf"
                />
              </Grid>
            </Grid>

            <Typography sx={{ pt: 10, fontSize: "32px", fontWeight: 500 }}>
              {t("fda")}
            </Typography>
            <Typography sx={{ lineHeight: "170%", pt: 1 }}>
              {t("fda1")}
            </Typography>
            <Grid
              container
              sx={{
                width: 1,

                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <Grid
                item
                sm={4}
                md={2}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  pt: 3,
                }}
              >
                <TestReport
                  img="img/fda2.jpeg"
                  content={t("fda2")}
                  src="FDA Listing - Prism Co., Ltd. 1.jpg"
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Grid
          maxWidth="lg"
          container
          sx={{
            width: 1,
            display: "flex",
            alignItems: "center",
            flexDirection: "row",
            // border: "1px solid black",
          }}
        >
          <Grid item sm={12} sx={{ px: 6, pt: 10, pb: 20, fontSize: "30px" }}>
            <Fade bottom>
              <Typography sx={{ pb: 1, color: "#153a5b" }}>
                {t("attainable")}
              </Typography>

              <Typography sx={{ fontSize: "32px", fontWeight: 500 }}>
                {t("possibility")}
              </Typography>
            </Fade>
            <Fade bottom delay={400}>
              <Typography sx={{ lineHeight: "170%", pt: 1, pb: 2 }}>
                {t("control")}
              </Typography>
            </Fade>
            <Grid
              container
              sx={{
                width: 1,
                display: "flex",
                mt: 2,
              }}
              direction="row"
              justifyContent="center"
              alignItems="center"
            >
              <Possibility
                title={t("tech_home")}
                exp={t("tech_home_exp")}
                img="https://images.unsplash.com/photo-1581578731548-c64695cc6952?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80"
              />

              <Possibility
                title={t("tech_kitchen")}
                exp={t("tech_kitchen_exp")}
                img="https://images.unsplash.com/photo-1610701596061-2ecf227e85b2?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80"
              />
              <Possibility
                title={t("clothing")}
                exp={t("clothing_exp")}
                img="https://images.unsplash.com/photo-1516762689617-e1cffcef479d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1011&q=80"
              />
              <Possibility
                title={t("Fitness")}
                exp={t("Fitness_exp")}
                img="https://images.unsplash.com/photo-1603793507927-52f3b7100ca6?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80"
              />
              <Possibility
                title={t("pet")}
                exp={t("pet_exp")}
                img="https://images.unsplash.com/photo-1603483936648-826289b147f2?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=774&q=80"
              />
            </Grid>
          </Grid>
        </Grid>
      </Box>
      <Container maxWidth="lg" sx={{ pb: 10, textAlign: "center" }}>
        <Fade bottom>
          <Typography variant="h4" sx={{ pb: 1 }}>
            {t("anti-bateria")}
          </Typography>
        </Fade>
        <fade delay={300}>
          <img src={t("anti-bateria-img")} alt="" style={{ width: "100%" }} />
        </fade>
      </Container>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          backgroundColor: "#f6f8fa",
        }}
      >
        <Grid
          maxWidth="lg"
          container
          sx={{
            width: 1,
            display: "flex",
            alignItems: "center",
            flexDirection: "row",
            // border: "1px solid black",
          }}
        >
          <Grid
            item
            sm={12}
            sx={{ px: 6, pt: 10, fontSize: "30px", textAlign: "center" }}
          >
            <Typography sx={{ fontSize: "32px", fontWeight: 500 }}>
              {t("need_help")}
            </Typography>
            <Typography sx={{ lineHeight: "170%", pt: 3, mb: 2 }}>
              {t("need_help2")}
            </Typography>

            <Container
              sx={{ display: "flex", justifyContent: "center", mt: 2, mb: 10 }}
            >
              <Grid
                container
                sx={{
                  width: 2 / 3,
                  display: "flex",
                  justifyContent: "center",
                  pt: 4,
                  pb: 7,
                }}
              >
                <Grid
                  item
                  xs={12}
                  md={5}
                  className={classes.help}
                  sx={{
                    py: 5,
                    mx: 1,
                    borderRadius: "10px",
                    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    backgroundColor: "white",
                  }}
                >
                  <InfoIcon sx={{ fontSize: "33px" }} />
                  <Link to="/faq#top">
                    <Box sx={{ pt: 1, fontSize: "22px" }}>
                      {t("help_center")}
                    </Box>
                  </Link>
                </Grid>
                <Grid
                  className={classes.help}
                  item
                  xs={12}
                  md={5}
                  sx={{
                    py: 5,
                    mx: 1,
                    borderRadius: "10px",
                    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    backgroundColor: "white",
                    mt: { xs: 2, md: 0 },
                  }}
                >
                  <SupportAgentIcon sx={{ fontSize: "33px" }} />
                  <Link to="/contact#top">
                    <Box sx={{ pt: 1, fontSize: "22px" }}>
                      {t("contact_support")}
                    </Box>
                  </Link>
                </Grid>
              </Grid>
            </Container>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default Tech;
const useStyles = makeStyles({
  questionLeft: {
    border: "2px solid #e7f5ff",
    borderRadius: "50px",
    padding: "20px",
    marginRight: "auto",

    backgroundColor: "#e7f5ff",
  },
  questionRight: {
    border: "2px solid #e7f5ff",
    borderRadius: "50px",
    padding: "20px",
    marginLeft: "auto",

    backgroundColor: "white",
  },
  help: { cursor: "pointer", "&:hover": { color: "#365672" } },
});
